import api from './api'

export const fetchNotificationPreferences = () =>
	api.get('/counseling/counselor/notification-preferences')

export const patchNotificationPreferences = preferences =>
	api.patch('/counseling/counselor/notification-preferences', preferences)
